import React, { FC } from 'react';
import { Loading } from '@clearcover/atlas';

import styles from './styles.module.css';

export const ProcessingModal: FC = () => {
  return (
    <div className={styles.wrapper} data-testid="processing-loading">
      <Loading size={80} />
    </div>
  );
};
